import _ from 'lodash'
let estadoCambio = [
    '-',
    'Sin Cambios',
    'Cambios Críticos',
    'Cambios Intrascendentes',
    'Cambios Aprobados'
]

export default class BlackBoxCapturas{
    constructor(){
        this.listaIRD = []
        this.listaVencimiento = []
        this.listaNoEncontrados = []
        this.filtroCritico = []
        this.filtroNoMedible = []
        this.filtroSKU = []
        this.filtroBarra = []
        this.filtroDescriptor = []
        this.filtroLaboratorio = []
        this.filtroItems = []
        this.filtroStock = []
        this.filtroDiferencia = []
        this.filtroTotalConteo = []
        this.filtroMalEnfocado = []
        this.filtroLote = []
        this.filtroVencido = []
        this.filtroVencidoPolitica = []
        this.filtroFechaVencimiento = []
        this.filtroVendedor = []
    }
    reset(){
        this.listaIRD = []
        this.listaVencimiento = []
        this.listaNoEncontrados = []
        this.filtroCritico = []
        this.filtroNoMedible = []
        this.filtroSKU = []
        this.filtroBarra = []
        this.filtroDescriptor = []
        this.filtroLaboratorio = []
        this.filtroItems = []
        this.filtroStock = []
        this.filtroDiferencia = []
        this.filtroTotalConteo = []
        this.filtroMalEnfocado = []
        this.filtroLote = []
        this.filtroVencido = []
        this.filtroVencidoPolitica = []
        this.filtroFechaVencimiento = []
        this.filtroVendedor = []
    }
    addIRD(capturaIRD){
        this.listaIRD.push(capturaIRD)
    }
    addVencimiento(capturaVencimiento){
        this.listaVencimiento.push(capturaVencimiento)
    }
    addNoEncontrado(capturaNoEncontrado){
        this.listaNoEncontrados.push(capturaNoEncontrado)
    }
    removeIRD(idCapturaAuditoriaIrd){
        let index = this.listaIRD.findIndex(captura=>captura.idCapturaAuditoriaIrd===idCapturaAuditoriaIrd)
        if(index>=0) this.listaIRD.splice(index, 1)
    }
    removeVencimiento(idCapturaAuditoriaVencimiento){
        let index = this.listaVencimiento.findIndex(captura=>captura.idCapturaAuditoriaVencimiento===idCapturaAuditoriaVencimiento)
        if(index>=0) this.listaVencimiento.splice(index, 1)
    }
    actualizaCapturaIRD(capturaIRDActualizada){
        this.listaIRD = this.listaIRD.map(captura=>{
            if(captura.idCapturaAuditoriaIrd == capturaIRDActualizada.idCapturaAuditoriaIrd){
                return capturaIRDActualizada
            }
            return captura
        })
        this.actualizarFiltrosIRD()
    }
    actualizaCapturaVencimiento(capturaVencimientoActualizada){
        this.listaVencimiento = this.listaVencimiento.map(captura=>{
            if(captura.idCapturaAuditoriaVencimiento == capturaVencimientoActualizada.idCapturaAuditoriaVencimiento){
                return capturaVencimientoActualizada
            }
            return captura
        })
        this.actualizarFiltrosVencimiento()
    }
    actualizaCapturaNoEncontrado(capturaNoEncontradoActualizada){
        this.listaNoEncontrados = this.listaNoEncontrados.map(captura=>{
            if(captura.idCapturaNoEncontrado == capturaNoEncontradoActualizada.idCapturaNoEncontrado){
                return capturaNoEncontradoActualizada
            }
            return captura
        })
        this.actualizarFiltrosNoEncontrados()
    }
    
    ordenarListaIRD(){
        let porItems = (captura)=>captura.items

        this.listaIRD = _.sortBy(this.listaIRD, porItems)
    }

    ordenarListaVencimiento(){
        let porItems = (captura)=>captura.items

        this.listaVencimiento = _.sortBy(this.listaVencimiento, porItems)
    }
    ordenarListaNoEncontrados(){
        let porVendedor = (captura) => captura.cod_vendedor
        let porSku = (captura) => captura.sku
        this.listaNoEncontrados = _.orderBy(this.listaNoEncontrados, [porVendedor, porSku], ['asc', 'asc'])
    }
    actualizarFiltrosIRD(){
        this.filtroCritico = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.critico
                let texto = estadoCambio[captura.critico]
                let opcion = _.find(this.filtroCritico, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroSKU = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.sku
                let texto = captura.sku

                let opcion = _.find(this.filtroSKU, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()       
        this.filtroBarra = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.barra
                let texto = captura.barra

                let opcion = _.find(this.filtroBarra, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroDescriptor = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.descriptor
                let texto = captura.descriptor

                let opcion = _.find(this.filtroDescriptor, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroLaboratorio = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.laboratorio
                let texto = captura.laboratorio

                let opcion = _.find(this.filtroLaboratorio, {'valor': valor})
                return opcion? opcion: {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroItems = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.items
                let texto = captura.items

                let opcion = _.find(this.filtroItems, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroStock = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.stock
                let texto = captura.stock

                let opcion = _.find(this.filtroStock, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroDiferencia = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.diferencia
                let texto = captura.diferencia

                let opcion = _.find(this.filtroDiferencia, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroTotalConteo = _.chain(this.listaIRD)
            .map(captura=>{
                let valor = captura.total_conteo
                let texto = captura.total_conteo

                let opcion = _.find(this.filtroTotalConteo, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
    }
    actualizarFiltrosVencimiento(){
        this.filtroCritico = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.critico
                let texto = estadoCambio[captura.critico]      //'-- NO ASIGNADO --'
                let opcion = _.find(this.filtroCritico, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroSKU = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.sku
                let texto = captura.sku

                let opcion = _.find(this.filtroSKU, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()       
        this.filtroBarra = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.barra
                let texto = captura.barra

                let opcion = _.find(this.filtroBarra, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroDescriptor = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.descriptor
                let texto = captura.descriptor

                let opcion = _.find(this.filtroDescriptor, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroLaboratorio = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.laboratorio
                let texto = captura.laboratorio

                let opcion = _.find(this.filtroLaboratorio, {'valor': valor})
                return opcion? opcion: {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroItems = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.items
                let texto = captura.items

                let opcion = _.find(this.filtroItems, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroLote = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.lote
                let texto = captura.lote

                let opcion = _.find(this.filtroLote, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroVencido = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.vencido
                let texto = captura.vencido? 'Si' : 'No'

                let opcion = _.find(this.filtroVencido, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroVencidoPolitica = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.vencido_politica
                let texto = captura.vencido_politica? 'Si' : 'No'

                let opcion = _.find(this.filtroVencidoPolitica, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroFechaVencimiento = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.fecha_vencimiento
                let texto = captura.fecha_vencimiento

                let opcion = _.find(this.filtroFechaVencimiento, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroMalEnfocado = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.malEnfocado
                let texto = captura.malEnfocado? 'Si' : 'No'

                let opcion = _.find(this.filtroMalEnfocado, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroNoMedible = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.noMedible
                let texto = captura.noMedible? 'Si' : 'No'

                let opcion = _.find(this.filtroNoMedible, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroVendedor = _.chain(this.listaVencimiento)
            .map(captura=>{
                let valor = captura.cod_vendedor
                let texto = captura.cod_vendedor

                let opcion = _.find(this.filtroVendedor, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
    }
    actualizarFiltrosNoEncontrados(){
        this.filtroSKU = _.chain(this.listaNoEncontrados)
            .map(captura=>{
                let valor = captura.sku
                let texto = captura.sku

                let opcion = _.find(this.filtroSKU, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroVendedor = _.chain(this.listaNoEncontrados)
            .map(captura=>{
                let valor = captura.cod_vendedor
                let texto = captura.cod_vendedor

                let opcion = _.find(this.filtroVendedor, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado:true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
    }
    reemplazarFiltro(nombreFiltro, filtroActualizado){
        if(this[nombreFiltro]){
            this[nombreFiltro] = filtroActualizado
        }else{
            console.error(`Filtro ${nombreFiltro} no existe`)
        }
    }
    getListaFiltradaIRD(){
        this.actualizarFiltrosIRD()

        return{
            capturaIRDFiltrada: _.chain(this.listaIRD)
                .filter(captura=>{
                    return _.find(this.filtroCritico, {'valor': captura.critico, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroSKU, {'valor': captura.sku, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroBarra, {'valor': captura.barra, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroDescriptor, {'valor': captura.descriptor, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroLaboratorio, {'valor': captura.laboratorio, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroItems, {'valor': captura.items, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroStock, {'valor': captura.stock, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroDiferencia, {'valor': captura.diferencia, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroTotalConteo, {'valor': captura.total_conteo, 'seleccionado': true})
                })
                .value(),
            filtrosIRD: {
                filtroCritico: this.filtroCritico,
                filtroSKU: this.filtroSKU,
                filtroBarra: this.filtroBarra,
                filtroDescriptor: this.filtroDescriptor,
                filtroLaboratorio: this.filtroLaboratorio,
                filtroItems: this.filtroItems,
                filtroStock: this.filtroStock,
                filtroDiferencia: this.filtroDiferencia,
                filtroTotalConteo: this.filtroTotalConteo
            },
            listaIRD: this.listaIRD
        }
    }
    getListaFiltradaVencimiento(){
        this.actualizarFiltrosVencimiento()

        return{
            capturaVencimientoFiltrada: _.chain(this.listaVencimiento)
                .filter(captura=>{
                    return _.find(this.filtroCritico, {'valor': captura.critico, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroSKU, {'valor': captura.sku, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroBarra, {'valor': captura.barra, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroDescriptor, {'valor': captura.descriptor, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroLaboratorio, {'valor': captura.laboratorio, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroItems, {'valor': captura.items, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroLote, {'valor': captura.lote, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroVencido, {'valor': captura.vencido, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroVencidoPolitica, {'valor': captura.vencido_politica, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroFechaVencimiento, {'valor': captura.fecha_vencimiento, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroMalEnfocado, {'valor': captura.malEnfocado, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroNoMedible, {'valor': captura.noMedible, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroVendedor, {'valor': captura.cod_vendedor, 'seleccionado': true})
                })
                .value(),
            filtrosVencimiento: {
                filtroCritico: this.filtroCritico,
                filtroSKU: this.filtroSKU,
                filtroBarra: this.filtroBarra,
                filtroDescriptor: this.filtroDescriptor,
                filtroLaboratorio: this.filtroLaboratorio,
                filtroItems: this.filtroItems,
                filtroLote: this.filtroLote,
                filtroVencido: this.filtroVencido,
                filtroVencidoPolitica: this.filtroVencidoPolitica,
                filtroFechaVencimiento: this.filtroFechaVencimiento,
                filtroMalEnfocado: this.filtroMalEnfocado,
                filtroNoMedible: this.filtroNoMedible,
                filtroVendedor: this.filtroVendedor
            },
            listaVencimiento: this.listaVencimiento
        }
    }
    getListaFiltradaNoEncontrados(){
        this.actualizarFiltrosNoEncontrados()
        return{
            capturaNoEncontradosFiltrada: _.chain(this.listaNoEncontrados)
                .filter(captura=>{
                    return _.find(this.filtroSKU, {'valor': captura.sku, 'seleccionado': true})
                })
                .filter(captura=>{
                    return _.find(this.filtroVendedor, {'valor': captura.cod_vendedor, 'seleccionado': true})
                })
                .value(),
            filtrosNoEncontrados: {
                filtroSKU: this.filtroSKU,
                filtroVendedor: this.filtroVendedor
            },
            listaNoEncontrados: this.listaNoEncontrados
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/BlackBoxCapturas.js